import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_PORTOFOLIO_ERROR, GET_PORTOFOLIO_START, GET_PORTOFOLIO_SUCCESS } from '../../types';

import apiCall from '../../../api/apiGet';

export function* get({ payload }) {
  try {
    const url = payload.lang ? `/portofolio/${payload.lang}` : '/portofolio/';
    const method = 'GET';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: GET_PORTOFOLIO_SUCCESS, results: results.data });

  } catch (error) {
    console.log(error)
    yield put({ type: GET_PORTOFOLIO_ERROR, error });
  }
}

export default function* get_portofolio() {
  yield takeLatest(GET_PORTOFOLIO_START, get);
}
